export default {
      id: "ic-para-heart-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-para-heart-usage",
      toString: function () {
        return this.url;
      }
    }